import { Flex, Tabs, Text } from "@instructure/ui";
import { t } from "i18next";
import { useState } from "react";
import { Actions } from "../../../../components/Action/Actions";
import { Card } from "../../../../components/Card";
import { ContextReflections } from "../../../../components/Reflection/ContextReflections";
import ChartData from "../../../../sections/ChartData";
import ApprovedOutcomesList from "../Components/ApprovedOutcomesList";
import UnapprovedOutcomesList from "../Components/UnapprovedOutcomesList";

const CourseView = ({
  currentSection,
  reflectionTemplates,
  sectionRefTemplate,
  dashboardFilters,
  setDashboardFilters,
  trigger,
  setTrigger,
  chartLoad,
  setChartLoad,
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [outcomeTabIndex, setOutcomeTabIndex] = useState(0);

  const handleFacultyTabChange = (_e, { index }) => setTabIndex(index);

  const handleOutcomeTabChange = (_e, { index }) => setOutcomeTabIndex(index);

  return (
    <Flex
      alignItems="start"
      wrap="wrap"
      gap="medium"
      width="100%"
      justifyItems="space-between"
    >
      <Flex.Item shouldGrow size="100%">
        <ChartData
          showLineChart
          showBarChart={false}
          inCourse
          isFacultyDash
          filters={dashboardFilters}
          setFilters={setDashboardFilters}
          trigger={trigger}
          setTrigger={setTrigger}
          section={currentSection}
          chartLoad={chartLoad}
          setChartLoad={setChartLoad}
          courseID={currentSection.canvas_id}
        />
      </Flex.Item>
      <Flex.Item size="100%">
        <Card style={{ height: 600 }}>
          <Flex justifyItems="space-between" gap="small" alignItems="start">
            <Flex.Item shouldShrink shouldGrow size="48%">
              <Tabs onRequestTabChange={handleOutcomeTabChange} maxHeight={555}>
                <Tabs.Panel
                  id="approved-outcomes-faculty"
                  renderTitle={<Text>{t("dashboard.approvedOutcomes")}</Text>}
                  isSelected={outcomeTabIndex === 0}
                >
                  <ApprovedOutcomesList currentSection={currentSection} />
                </Tabs.Panel>
                <Tabs.Panel
                  id="unapproved-outcomes-faculty"
                  renderTitle={t("dashboard.unapprovedOutcomes")}
                  isSelected={outcomeTabIndex === 1}
                >
                  <UnapprovedOutcomesList currentSection={currentSection} />
                </Tabs.Panel>
              </Tabs>
            </Flex.Item>

            <Flex.Item>
              <div style={{ height: 600, borderRight: "1px solid #ccc" }} />
            </Flex.Item>
            <Flex.Item shouldShrink shouldGrow size="48%">
              <Tabs onRequestTabChange={handleFacultyTabChange}>
                <Tabs.Panel
                  id="reflections-faculty"
                  renderTitle={t("reflections.reflections")}
                  isSelected={tabIndex === 0}
                  padding="small 0"
                >
                  <div style={{ maxHeight: 525, padding: "0 10px" }}>
                    <ContextReflections
                      contextId={currentSection.id}
                      contextName={currentSection.name}
                      reflectionTemplates={reflectionTemplates}
                      sectionRefTemplate={sectionRefTemplate}
                    />
                  </div>
                </Tabs.Panel>
                <Tabs.Panel
                  id="actions-faculty"
                  renderTitle={t("actions.actions")}
                  isSelected={tabIndex === 1}
                  padding="small 0"
                >
                  <div style={{ maxHeight: 525, padding: "0 10px" }}>
                    <Actions contextId={currentSection.id} />
                  </div>
                </Tabs.Panel>
              </Tabs>
            </Flex.Item>
          </Flex>
        </Card>
      </Flex.Item>
    </Flex>
  );
};

export default CourseView;
